document.addEventListener(
  "click",
  function(event) {
    if (!event.target.matches(".socials__link--share")) return;

    event.preventDefault();

    window.open(
      event.target.href,
      "",
      "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600"
    );
  },
  false
);
